<p-card>
    <ng-template pTemplate="header">
        <div class="flex justify-between">
            <div class="p-card-title">Past Messages</div>
            <div><button pButton (click)="showNewMessage()">New</button></div>
        </div>
    </ng-template>
    <p-table [value]="textMessages()" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        sortMode="multiple" [resizableColumns]="true" columnResizeMode="fit">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="sendDate" pResizableColumn class="w-32">Send Date <p-sortIcon field="sendDate"></p-sortIcon></th>
                <th pSortableColumn="staffName" pResizableColumn class="w-32">Sent By <p-sortIcon field="staffName"></p-sortIcon></th>
                <th pSortableColumn="recipientCount" pResizableColumn class="w-32">Recipient Count <p-sortIcon field="recipientCount"></p-sortIcon>
                </th>
                <th pSortableColumn="unsubscribeCount" pResizableColumn class="w-32">Unsubscribe Count <p-sortIcon
                        field="unsubscribeCount"></p-sortIcon></th>
                <th pResizableColumn>Message</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-textMessage>
            <tr>
                <td>
                    {{textMessage.sendDate | date:"MM/dd/yyyy hh:mm aa"}}
                </td>
                <td>
                    {{textMessage.staffName}}
                </td>
                <td>
                    <div class="flex justify-end">{{textMessage.recipientCount}}</div>
                </td>
                <td>
                    <div class="flex justify-end">{{textMessage.unsubscribeCount}}</div>
                </td>
                <td>
                    {{textMessage.messageText}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>

<p-dialog [(visible)]="dialogVisible" [closable]="true" [modal]="true" header="New Text Message">
    <app-send-text-message (messageSent)="messageSent()"></app-send-text-message>
</p-dialog>